// extracted by mini-css-extract-plugin
export var footer = "_mo-0";
export var inherit = "_mo-1";
export var input = "_mo-2";
export var modalContent = "_mo-3";
export var quillEditor = "_mo-4";
export var subtitle = "_mo-5";